import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_SUSCRIPCIONES = 'ALL_SUSCRIPCIONES';
export const LOADING_ALL_SUSCRIPCIONES = 'LOADING_ALL_SUSCRIPCIONES';
export const ACTIVO_SUSCRIPCIONES = 'ACTIVO_SUSCRIPCIONES';
export const PARAMS_SUSCRIPCIONES = 'PARAMS_SUSCRIPCIONES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const suscripcionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_SUSCRIPCIONES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_SUSCRIPCIONES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_SUSCRIPCIONES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_SUSCRIPCIONES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
